(function () {
  const AUTOPLAY_DELAY = 6000;

  const slider = document.querySelector('.hero-slider__swiper');
  const progressBar = document.querySelector('.hero-slider__progress-bar');
  const counterCurrent = document.querySelector('.hero-slider__counter-current');
  const counterTotal = document.querySelector('.hero-slider__counter-total');

  if (!slider) return;

  let progressInterval = null;
  let progressStart = null;

  function startProgress() {
    clearProgress();
    progressStart = Date.now();

    progressInterval = setInterval(function () {
      const elapsed = Date.now() - progressStart;
      const pct = Math.min((elapsed / AUTOPLAY_DELAY) * 100, 100);
      if (progressBar) progressBar.style.width = pct + '%';
    }, 50);
  }

  function clearProgress() {
    clearInterval(progressInterval);
    if (progressBar) progressBar.style.width = '0%';
  }

  function updateCounter(index, total) {
    if (counterCurrent) counterCurrent.textContent = String(index + 1).padStart(2, '0');
    if (counterTotal) counterTotal.textContent = String(total).padStart(2, '0');
  }

  function handleVideos(swiper) {
    // Pause all videos
    swiper.slides.forEach(function (slide) {
      const video = slide.querySelector('.hero-slider__video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });

    // Play active slide video
    const activeVideo = swiper.slides[swiper.activeIndex]
      ? swiper.slides[swiper.activeIndex].querySelector('.hero-slider__video')
      : null;

    if (activeVideo) {
      activeVideo.play().catch(function () {});
    }
  }

  const swiper = new Swiper('.hero-slider__swiper', {
    loop: true,
    speed: 800,
    grabCursor: true,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    autoplay: {
      delay: AUTOPLAY_DELAY,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: '.hero-slider__arrow--next',
      prevEl: '.hero-slider__arrow--prev',
    },
    pagination: {
      el: '.hero-slider__pagination',
      clickable: true,
    },
    on: {
      init: function (s) {
        updateCounter(s.realIndex, s.slides.length - (s.loopedSlides * 2 || 0));
        startProgress();
        handleVideos(s);
      },
      slideChange: function (s) {
        updateCounter(s.realIndex, s.slides.length - (s.loopedSlides * 2 || 0));
        startProgress();
        handleVideos(s);
      },
      autoplayStop: function () {
        clearProgress();
      },
      autoplayStart: function () {
        startProgress();
      },
    },
  });
})();